const author = {
  en: {
    author: {
      include_unused_author: 'Include unused authors',
      tooltips: {
        unused_author: 'Use the toggle to reveal unused authors.',
        unused_author_disabled: "Select a date range to activate button."
      },
      table: {
        last_article: 'Last Article'
      },
      actions: {
        merge: 'Merge',
        delete: 'Delete',
        edit: 'Edit'
      }
    }
  }
}

module.exports.author = author;